import type { ComputedRef, Ref } from 'vue'
import type { EventDate } from '~/composables/types/event'
import { eventDateGetters } from '~/utils/eventDateGetters'

export const PREFERRED_DATE_ID_FROM_QUERY_KEY = Symbol(
  'preferredDateIdFromQuery'
)

export const usePreferredDateIdFromQuery = () => {
  return inject<ComputedRef<string | undefined> | Ref<string | undefined>>(
    PREFERRED_DATE_ID_FROM_QUERY_KEY,
    computed(() => undefined)
  )
}

export const pickPreferredOrFirstAvailableDate = (
  dates: EventDate[],
  preferredDateId?: string
): EventDate | undefined => {
  const openDates = dates.filter(
    (date) =>
      eventDateGetters.getDateIsOpen(date) &&
      eventDateGetters.getAvailableTicketsQuantity(date) > 0
  )

  if (preferredDateId) {
    const preferred = openDates.find((date) => date.id === preferredDateId)
    if (preferred) return preferred
  }

  return openDates[0]
}
